import { render, staticRenderFns } from "./PlanAssignment.vue?vue&type=template&id=5e80a4d2&scoped=true"
import script from "./PlanAssignment.vue?vue&type=script&lang=js"
export * from "./PlanAssignment.vue?vue&type=script&lang=js"
import style0 from "./PlanAssignment.vue?vue&type=style&index=0&id=5e80a4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e80a4d2",
  null
  
)

export default component.exports